var _defs, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAzurePortal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a31",
    x1: 9,
    y1: 15.427,
    x2: 9,
    y2: 5.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.175,
    stopColor: "#32caea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#32d2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#32d4f5"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.973h16v8.92a.535.535 0 01-.535.535H1.535A.535.535 0 011 14.893v-8.92z",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.538 2.563h14.924A.535.535 0 0117 3.1v2.873H1V3.1a.535.535 0 01.538-.537z",
    fill: "#198ab3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.973h4.194v9.455H1.536A.532.532 0 011 14.895V5.973z",
    fill: "#9cebff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.194 13.356H17V14.9a.532.532 0 01-.532.532H5.194v-2.076z",
    fill: "#32bedd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzurePortal);
export default __webpack_public_path__ + "static/media/azure-portal.abe15523feaaf4a4799183c2e55cdff0.svg";
export { ForwardRef as ReactComponent };